import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class DateDeserializationInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.body) {
          // Check if the response body is an object and iterate through its properties
          if (typeof event.body === 'object' && event.body !== null) {
            this.convertDates(event.body);
          }
        }
        return event;
      })
    );
  }

  private convertDates(obj: any) {
    // Iterate over the keys of the object
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (value === null) continue;
        // Look for a SimpleDate and convert it
        if (typeof value === 'object' && value.hasOwnProperty('Year') && value.hasOwnProperty('Month') && value.hasOwnProperty('Day')) {
          if (typeof value['Year'] === 'number' && typeof value['Month'] === 'number' && typeof value['Day'] === 'number') {
            obj[key] = new Date(value['Year'], value['Month'] - 1, value['Day']); // Convert to Date
          }
        }
        // If it's an object, recursively check for nested date fields
        else if (typeof value === 'object') {
          this.convertDates(value); // Recursively handle nested objects
        }
      }
    }
  }
}